import React from "react";
import { Check, Minus } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
const plans = [{
  name: "Estate",
  price: "$120",
  period: "/qtr",
  description: "A curated introduction to our seasonal vintages.",
  isPopular: false
}, {
  name: "Reserve",
  price: "$280",
  period: "/qtr",
  description: "Our most sought-after selection of reserve labels.",
  isPopular: true
}, {
  name: "Grand Cordon",
  price: "$550",
  period: "/qtr",
  description: "The pinnacle of our cellar, including limited library releases.",
  isPopular: false
}];
const features = [{
  name: "Seasonal Shipments",
  basic: "2 Bottles",
  pro: "6 Bottles",
  elite: "12 Bottles"
}, {
  name: "Complimentary Tastings",
  basic: "2/month",
  pro: "4/month",
  elite: "Unlimited"
}, {
  name: "Estate Access",
  basic: true,
  pro: true,
  elite: true
}, {
  name: "Member-Only Events",
  basic: true,
  pro: true,
  elite: true
}, {
  name: "Library Wine Access",
  basic: false,
  pro: true,
  elite: true
}, {
  name: "Flat-Rate Shipping",
  basic: false,
  pro: true,
  elite: true
}, {
  name: "Private Estate Tours",
  basic: false,
  pro: false,
  elite: "Annual"
}, {
  name: "Winemaker Consultation",
  basic: false,
  pro: false,
  elite: true
}, {
  name: "Barrel Room Access",
  basic: false,
  pro: false,
  elite: true
}, {
  name: "Anniversary Gift",
  basic: false,
  pro: false,
  elite: true
}];
export default function ChooseYourPath() {
  return <section data-section-id="14097" id="membership-levels" className="bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] bg-primary/5 rounded-full blur-[120px]" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[400px] h-[400px] bg-secondary/10 rounded-full blur-[100px]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-6xl font-serif tracking-tight italic mb-6">
            Join the <span className="text-primary">Cellar Club</span>
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl font-sans">
            Uncork exclusive benefits and rare vintages. Choose the membership level that complements your palate.
          </p>
        </div>

        <div className="relative w-full overflow-hidden rounded-sm border border-border bg-card/30 backdrop-blur-sm shadow-xl">
          <Table className="w-full">
            <TableHeader className="sticky top-0 z-20 bg-card/95 backdrop-blur-md supports-[backdrop-filter]:bg-card/80 shadow-sm">
              <TableRow className="border-b border-border hover:bg-transparent">
                <TableHead className="w-[30%] pl-6 py-8 align-bottom">
                  <span className="text-sm font-mono uppercase tracking-widest text-muted-foreground">
                    Club Benefits
                  </span>
                </TableHead>
                {plans.map((plan, i) => <TableHead key={plan.name} data-index={i} className={`text-center py-8 align-bottom relative ${plan.isPopular ? "bg-primary text-primary-foreground border-x border-primary shadow-lg" : ""}`}>
                    {plan.isPopular && <div className="absolute top-2 left-1/2 -translate-x-1/2">
                        <Badge className="bg-secondary text-secondary-foreground hover:bg-secondary uppercase tracking-widest text-[10px] px-3 py-1 rounded-sm shadow-md">
                          Most Popular
                        </Badge>
                      </div>}
                    <div className="flex flex-col gap-2 items-center">
                      <h3 className={`text-xl font-serif uppercase tracking-wider ${plan.isPopular ? "text-primary-foreground" : "text-foreground"}`}>
                        {plan.name}
                      </h3>
                      <div className="flex items-baseline gap-1">
                        <span className={`text-4xl font-serif ${plan.isPopular ? "text-primary-foreground" : "text-foreground"}`}>
                          {plan.price}
                        </span>
                        <span className={`text-xs font-mono uppercase ${plan.isPopular ? "text-primary-foreground/80" : "text-muted-foreground"}`}>
                          {plan.period}
                        </span>
                      </div>
                      <p className={`text-xs mx-auto font-sans px-2 ${plan.isPopular ? "text-primary-foreground/70" : "text-muted-foreground"}`}>
                        {plan.description}
                      </p>
                    </div>
                  </TableHead>)}
              </TableRow>
            </TableHeader>
            <TableBody>
              {features.map((feature, i) => <TableRow key={feature.name} data-index={i} className="border-b border-border/40 hover:bg-muted/10 transition-colors">
                  <TableCell className="font-sans pl-6 py-5 text-base text-foreground/80">
                    {feature.name}
                  </TableCell>
                  {plans.map((plan, j) => {
                const value = plan.name === "Estate" ? feature.basic : plan.name === "Reserve" ? feature.pro : feature.elite;
                return <TableCell key={`${feature.name}-${plan.name}`} data-index={j} className={`text-center py-5 ${plan.isPopular ? "bg-primary/5 border-x border-primary/10" : ""}`}>
                        <div className="flex justify-center items-center h-full">
                          {value === true ? <div className="size-2 rounded-full bg-secondary shadow-[0_0_6px_var(--color-secondary)]" /> : value === false ? <Minus className="size-4 text-muted-foreground/20" /> : <span className={`text-sm font-mono ${plan.isPopular ? "text-primary font-bold" : "text-foreground"}`}>
                              {value}
                            </span>}
                        </div>
                      </TableCell>;
              })}
                </TableRow>)}
              
              {}
              <TableRow className="border-t border-border hover:bg-transparent">
                <TableCell className="pl-6 py-8" />
                {plans.map((plan, i) => <TableCell key={`btn-${plan.name}`} data-index={i} className={`text-center py-8 ${plan.isPopular ? "bg-primary/5 border-x border-primary/10" : ""}`}>
                    <Button asChild variant={plan.isPopular ? "default" : "outline"} size="lg" className={`w-full max-w-[160px] font-sans uppercase tracking-widest text-xs rounded-sm transition-all duration-300 ${plan.isPopular ? "bg-primary text-primary-foreground hover:bg-primary/90 shadow-md" : "border-primary/30 text-primary hover:border-primary hover:bg-primary/5"}`}>
                      <Link to="#">
                        {plan.isPopular ? "Subscribe" : "Subscribe"}
                      </Link>
                    </Button>
                  </TableCell>)}
              </TableRow>
            </TableBody>
          </Table>
        </div>

        <div className="mt-12 text-center">
          <p className="text-muted-foreground text-xs font-mono uppercase tracking-tight">
            * Shipments occur quarterly. Membership may be cancelled after two consecutive shipments.
          </p>
        </div>
      </div>
    </section>;
}